export const PAGE_TYPES: { [key: string]: string } = {
  'about-page': 'article',
  'contact-form-page': 'contact',
  'gated-contact-page': 'form',
  'home-page': 'home',
  'product-page': 'product',
  contactPage: 'contact',
  gatedContactPage: 'gated-contact',
  homePage: 'home',
  article: 'article',
  formPage: 'form',
  productPage: 'product',
  contentOverviewPage: 'content-overview',
  productOverviewPage: 'products-overview',
  wizardPage: 'wizard',
  wizardResultPage: 'wizard-result',
  overviewPage: 'overview-page',
  pageNotFound: '404',
};

export const CARD_WRAPPER_TYPES = {
  anchorWrapper: 'anchor-wrapper',
  featuredArticlesWrapper: 'featured-articles-wrapper',
  filterableArticlePreviewsWrapper: 'filterable-article-previews-wrapper',
  faqWrapper: 'faq-wrapper',
  formWrapper: 'form-wrapper',
  gatedContentWrapper: 'gated-content-wrapper',
  ungatedContentWrapper: 'ungated-content-wrapper',
  stepHorizontalWrapper: 'steps-horizontal-wrapper',
  stepVerticalWrapper: 'steps-vertical-wrapper',
  previewCardWrapper: 'preview-card-wrapper',
  promovisualWrapper: 'promovisual-wrapper',
  quoteWrapper: 'quote-wrapper',
  storyCardsWrapper: 'story-cards-wrapper',
  linkCardsWrapper: 'link-cards-wrapper',
  uspWrapper: 'usp-wrapper',
  wizardWrapper: 'wizard-wrapper',
  wizardResultsWrapper: 'wizard-results-wrapper',
  tileWrapper: 'tile-wrapper',
  productFeaturesWrapper: 'product-features-wrapper',
  feedbackCardWrapper: 'feedback-card-wrapper',
  iconListWrapper: 'icon-list-wrapper',
  linkTilesWrapper: 'link-tiles-wrapper',
  genericCardWrapper: 'generic-card-wrapper',
  socialProofWrapper: 'social-proof-wrapper',
  testimonialWrapper: 'testimonial-wrapper',
};

export const CARD_TYPES = {
  anchor: 'anchor',
  disclaimer: 'disclaimer',
  featuredArticle: 'featured-article',
  faqItem: 'faq-item',
  header: 'header',
  highlight: 'highlight',
  imageOrVideoOnly: 'image-or-video-only',
  promovisual: 'promovisual',
  previewCard: 'preview-card',
  quote: 'quote',
  step: 'step',
  storyCard: 'story-card',
  linkCard: 'link-card',
  tile: 'tile',
  usp: 'usp',
  uspNumerical: 'usp-numerical',
  embeddedVideoCard: 'embedded-video-card',
  animatedVideoCard: 'animated-video-card',
  resultOptionCard: 'result-option-card',
  download: 'download',
  productFeature: 'product-feature',
  tip: 'tip',
  iconListItem: 'icon-list-item',
  linkTile: 'link-tile',
  generic: 'generic',
  subhomeTopComponent: 'subhome-top-component',
  productCard: 'product-card',
  wizardCard: 'wizard-card',
  contentHighlight: 'content-highlight',
  gatedDownloadCard: 'gated-download-card',
  articlePreviewCard: 'article-preview-card',
  sales: 'sales',
  iframeCard: 'iframe-card',
  socialProofCard: 'social-proof-card',
  fullScreenHeader: 'full-screen-header',
  productRippleHeader: 'product-ripple-header',
  cta: 'cta',
  fullWidthVideoCard: 'full-width-video-card',
  wizardHeader: 'wizardHeader',
  testimonial: 'testimonial',
};

export const CONTENTFUL_INPUT_TYPES = {
  text: 'text',
  email: 'email',
  tel: 'tel',
  number: 'number',
  file: 'file',
  textarea: 'textarea',
  search: 'search',
  url: 'url',
  password: 'password',
  radio: 'radio',
  checkbox: 'checkbox',
  date: 'date',
};

export const FORM_CONTEXT_TYPES = {
  currency: 'currency',
  kvkNumber: 'kvk-number',
  specialCharacters: 'special-characters',
  postalCode: 'postal-code',
  accountNumber: 'account-number',
  numbersLettersOnly: 'numbers-letters-only',
};

export const CONTENTFUL_COMPONENT = {
  formInput: 'ContentfulFormInput',
  formInputGroup: 'ContentfulFormInputGroup',
  formResult: 'ContentfulFormResult',
  wizardCheckbox: 'ContentfulWizardComponentCheckbox',
  fieldset: 'ContentfulFieldset',
  pageProductOverview: 'ContentfulPageProductOverview',
  wizardOption: 'ContentfulWizardOption',
  wizardStep: 'ContentfulWizardStep',
  formContactForm: 'ContentfulFormContactForm',
  articlePage: 'ContentfulPageArticle',
  card: 'ContentfulCompCard',
  cardWrapper: 'ContentfulCompCardWrapper',
  calculator: 'ContentfulCompCalculator',
  wizard: 'ContentfulCompWizard',
  tabWrapper: 'ContentfulTabWrapper',
  genericPage: 'ContentfulPageGeneric',
  textSection: 'ContentfulArticleTextSection',
  wizardHeader: 'ContentfulCompWizardHeader',
};

export const CONTENTFUL_SLUGS = {
  home: '#',
  productOverview: '/hulpmiddelen-en-diensten',
  unsubscribeCommunications: 'afmelden-communicaties',
  downloadFeedbackForm: 'download-feedback-formulier',
};

export const CONTENTFUL_PAGE_NAME = {
  home: 'Home',
  slim: 'Slim ondernemen',
  duurzaam: 'Duurzaam ondernemen',
  veilig: 'Veilig ondernemen',
};

export const CONTENTFUL_FORM_NAME = {
  threadstone: 'Contact form - Cyber MKB',
};

// eslint-disable-next-line no-shadow
export enum PageType {
  CONTACT_FORM = 'contact-form-page',
  GATED_CONTACT = 'gated-contact-page',
  HOME = 'home-page',
  PRODUCT = 'product-page',
  GENERIC = 'generic-page',
  WIZARD = 'wizard-page',
  WIZARD_RESULT = 'wizard-result-page',
  PAGE_NOT_FOUND = '404-page',
}

// eslint-disable-next-line no-shadow
export enum ContentfulLayout {
  DEFAULT = 'default',
  RESTRICTED = 'restricted',
  ISOLATED = 'isolated',
}

export const FORMINPUT_LEAD_TYPES = {
  name: 'name',
  kvk: 'kvk',
  company: 'company',
  email: 'email',
  phone: 'phone',
  comments: 'comments',
  role: 'role',
  abnClient: 'abn_client',
  abnBusinessClient: 'abn_business_client',
  employees: 'employees',
  numberOfLocations: 'number_of_locations',
  contactRequestReason: 'contact_request_reason',
  purposeOfPlanUsage: 'purpose_of_plan_usage',
  companyStartProcess: 'company_start_process',
  webshop: 'webshop',
  appointmentDate: 'appointment_date',
  appointmentTime: 'appointment_time',
  partnerAbn: 'partner_abn',
  website: 'website',
  additionalInfo: 'additional_info',
  sector: 'sector',
} as const;

export const CHECKBOX_LEAD_TYPES = {
  isConsented: 'is_consented',
  isConsentedInsightsNewsletter: 'is_consented_insights_newsletter',
} as const;
